import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

export const ValidationTextField = styled(TextField)({
    "& input:valid + fieldset": {  borderWidth: 2 },
    "& input:valid:focus + fieldset": {
      borderLeftWidth: 6,
      padding: "4px !important",
    },
  });